import { render, staticRenderFns } from "./showtip.vue?vue&type=template&id=b0a1849c&scoped=true"
import script from "./showtip.vue?vue&type=script&lang=js"
export * from "./showtip.vue?vue&type=script&lang=js"
import style0 from "./showtip.vue?vue&type=style&index=0&id=b0a1849c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a1849c",
  null
  
)

export default component.exports